<template>
    <!-- eslint-disable max-len -->
    <v-row>
      <v-col>
        <!-- comments -->
        <div class="mt-0">
          <p class="title" v-bind:class="{'primary--text': !isSummaryView}">
            <span v-if="isSelfSurvey" class="font-weight-black">
              What are your strengths and development areas? Please provide specific examples.
            </span>
            <span v-else class="font-weight-black">
              What are {{ params.EvaluateeFullName }}'s strengths and development areas? Please provide specific examples.
            </span>
          </p>
          <v-textarea v-if="!isSummaryView"
                      v-model="verbatimResponse"
                      :rules="[
                      v=>
            currentStep !== this.$props.pageNr ||
            (!!v && v.length > 0) ||
            'Please share your comments.',
            ]"
            required
            outlined
            >
          </v-textarea>
            <p v-if="isSummaryView" class="font-weight-regular">
              {{verbatimResponse == null ? 'No Comments Provided':verbatimResponse}}
            </p>
        </div>
      </v-col>
    </v-row>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Verbatim',

  props: ['verbatim', 'pageNr', 'isSummaryView'],

  data() {
    return {
    };
  },

  methods: {
    storeResponse(responseField, responseValue) {
      this.$store.commit('storeResponse', responseField, responseValue);
    },
    manualValidateForm() {
      this.$emit('validate-form');
    },
  },

  computed: {
    ...mapGetters([
      'currentStep',
      'isSelfSurvey',
    ]),
    params() {
      return this.$store.state.params;
    },
    // Survey Responses
    verbatimResponse: {
      get() {
        return this.$store.state.response[`${this.verbatim.field}`];
      },
      set(newValue) {
        this.$store.commit('storeResponse', {
          k: `${this.verbatim.field}`,
          v: newValue,
        });
      },
    },
  },
};
</script>
